import { IS_PHONE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { renderNewComfirmationDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';

export const showSassNoTariffDialog = () => {
    renderNewComfirmationDialog({
        dataQAId: 'no-tariff-dialog',
        renderHeader: () => (IS_PHONE_BROWSER ? ' Тариф недоступен' : 'Данный тариф недоступен'),
        renderContent: () => 'Попробуйте сменить аккаунт или выберите другой тариф',
        buttons: [EButtonType.accept],
        successButtonText: 'Понятно',
    });
};
